export let privateGroupTooltip = "zLcxgc";
export let publicGroupTooltip = "NzHrlc";
export default {privateGroupTooltip,publicGroupTooltip};